<script lang="ts" setup>
</script>

<template>
  <header class="w-full text-center mb-22">
    <SiteLogo/>
  </header>
</template>

<style scoped>
</style>